import { render, staticRenderFns } from "./ThemeSelector.vue?vue&type=template&id=64e0c906"
import script from "./ThemeSelector.vue?vue&type=script&lang=js"
export * from "./ThemeSelector.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports